module.exports = __webpack_public_path__ + "media/images/pt/performance-index-continuum-full-7b0763b9af6d1f938151792a4ad6d4ca.jpg";